<template>
  <b-modal
    ref="upsertModal"
    v-model="showModal"
    centered
    size="lg"
    :no-close-on-backdrop="true"
    cancel-variant="danger"
    :title="isUpdatingRole ? $t('edit_product') : $t('add_product')"
    @hidden="clearForm"
  >
    <b-overlay
      variant="transparent"
      opacity="0.6"
      :show="isFetching"
    >
      <ValidationObserver ref="vObserver">
        <b-row>
          <!--    ? NAME[UZ]    -->
          <b-col cols="12">
            <label> {{ $t('title') }} [UZ] </label>
            <ValidationProvider
              v-slot="{ errors }"
              name="name(uz)"
              rules="required"
            >
              <b-form-group>
                <b-form-input
                  v-model="details.name.uz"
                  :placeholder="`${$t('enter')} ${$t('title')} [UZ]`"
                  :state="errors.length > 0 ? false : null"
                  size="md"
                />
              </b-form-group>
              <span class="validation__red">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </b-col>

          <!--    ? NAME[RU]    -->
          <b-col cols="12">
            <label> {{ $t('title') }} [RU] </label>
            <ValidationProvider
              v-slot="{ errors }"
              name="name(ru)"
              rules="required"
            >
              <b-form-group>
                <b-form-input
                  v-model="details.name.ru"
                  :placeholder="`${$t('enter')} ${$t('title')} [RU]`"
                  :state="errors.length > 0 ? false : null"
                  size="md"
                />
              </b-form-group>
              <span class="validation__red">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>

          <!--    ? DESCRIPTION [UZ]    -->
          <b-col cols="12">
            <label> {{ $t('description') }} [UZ] </label>
            <ValidationProvider
              v-slot="{ errors }"
              name="description(uz)"
              rules="required"
            >
              <b-form-group>
                <b-form-textarea
                  v-model="details.description.uz"
                  :placeholder="`${$t('enter')} ${$t('description')} [UZ]`"
                />
              </b-form-group>
              <span class="validation__red">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </b-col>

          <!--    ? DESCRIPTION [RU]    -->
          <b-col cols="12">
            <label> {{ $t('description') }} [RU] </label>
            <ValidationProvider
              v-slot="{ errors }"
              name="description(ru)"
              rules="required"
            >
              <b-form-group>
                <b-form-textarea
                  id="textarea-default"
                  v-model="details.description.ru"
                  :placeholder="`${$t('enter')} ${$t('description')} [RU]`"
                />
              </b-form-group>
              <span class="validation__red">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>

          <!--    ? POSITION    -->
          <b-col cols="12">
            <label> {{ $t('position') }}</label>
            <ValidationProvider
              v-slot="{ errors }"
              name="Position"
              rules="required"
            >
              <b-form-group>
                <b-form-input
                  v-model="details.position"
                  type="number"
                  :placeholder="$t('position')"
                  :state="errors.length > 0 ? false : null"
                  size="md"
                />
              </b-form-group>
              <span class="validation__red">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>

          <!--    ? SIZES    -->
          <b-col cols="12">
            <b-row
              v-for="(sz,szIndex) in details.sizes"
              :key="szIndex"
            >
              <!--      ? SIZE        -->
              <b-col :cols="szIndex === 0 ? 4 : 5">
                <label> {{ $t('sizes') }}({{ szIndex + 1 }}):</label>
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="`Size(${ szIndex+1 })`"
                  rules="required"
                >
                  <b-form-group>
                    <b-form-input
                      v-model.number="sz.size"
                      type="number"
                      :placeholder="`${$t('sizes')}(${szIndex})`"
                      :state="errors.length > 0 ? false : null"
                      size="md"
                    />
                  </b-form-group>
                  <span class="validation__red">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>

              <!--      ? PRICE        -->
              <b-col :cols="szIndex === 0 ? 4 : 5">
                <label> {{ $t('price') }}({{ szIndex + 1 }}):</label>
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="`Price(${ szIndex+1 })`"
                  rules="required"
                >
                  <b-form-group>
                    <b-form-input
                      v-model.number="sz.price"
                      type="number"
                      :placeholder="`${$t('price')}(${szIndex})`"
                      :state="errors.length > 0 ? false : null"
                      size="md"
                    />
                  </b-form-group>
                  <span class="validation__red">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>

              <b-col
                v-if="szIndex === 0"
                class="mt-2"
              >
                <b-button
                  variant="primary"
                  size="md"
                  @click="addNewSize"
                >
                  {{ $t('add_price') }}
                </b-button>
              </b-col>

              <!--  ?  REMOVE BUTTON       -->
              <b-col
                v-if="szIndex !== 0"
                cols="2"
                class="mt-2"
              >
                <b-button
                  variant="danger"
                  size="sm"
                  @click="removeSize(szIndex)"
                >
                  <feather-icon
                    icon="DeleteIcon"
                    size="18"
                    class="cursor-pointer"
                  />
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <!--    ? IMAGE      -->
          <b-col cols="12">
            <label :class="imageBaseUrl ? 'mb-1' :''"> {{ $t('product_image') }} </label>
            <ValidationProvider
              v-slot="{ errors }"
              name="Image"
              :rules="isUpdatingRole ? '' : 'required'"
            >
              <b-form-group>
                <div class="d-flex">
                  <b-img
                    v-if="imageBaseUrl"
                    :src="imageBaseUrl"
                    alt="upload image"
                    style="width: 10rem;height: 8rem;object-fit: cover"
                    class="mr-1"
                    rounded
                    thumbnail
                  />
                  <b-form-file
                    ref="refImageEl"
                    v-model="details.image"
                    accept="image/*"
                    @input="inputImageRenderer"
                  />
                </div>
              </b-form-group>
              <span class="validation__red">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>

          <!--    ? PUBLISH   -->
          <b-col
            cols="12"
            class="my-1 "
          >
            <b-form-checkbox v-model="details.public">
              {{ $t('is_published') }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </ValidationObserver>
    </b-overlay>

    <template #modal-footer>
      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block"
      >
        <b-button
          variant="primary"
          @click="submit"
        >
          {{ isUpdatingRole ? $t('edit') : $t('add') }}
        </b-button>
      </b-overlay>
    </template>
  </b-modal>
</template>

<script>
import {
  computed, ref, watch, watchEffect,
} from '@vue/composition-api'
import {
  BModal,
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BOverlay,
  BFormCheckbox,
  BFormFile,
  BFormTextarea,
  BImg,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { isNull } from '@/util/inspect'
import useLoading from '@/composables/useLoading'
import useProduct from '@/composables/useProduct'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { API_BASE_URL } from '@/services/axios'

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BButton,
    BFormGroup,
    BFormInput,
    BOverlay,
    BFormCheckbox,
    BFormFile,
    BFormTextarea,
    BImg,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    id: {
      type: [Number, String, Object],
      default: null,
    },
    methodType: {
      type: String,
      default: 'create',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:show', 'update:data'],
  setup(props, { emit }) {
    const {
      create,
      edit,
      findOne,
    } = useProduct()

    const {
      isLoading: isFetching,
      startLoading: startFetching,
      finishLoading: finishFetching,
    } = useLoading()

    const {
      isLoading,
      startLoading,
      finishLoading,
    } = useLoading()

    const vObserver = ref(null)
    const details = ref({
      name: {
        uz: '',
        ru: '',
      },
      position: null,
      image: null,
      /* ? @sizes
      ?  {
      ?     size: number
      ?     price: number
      ?  }
      ? */
      sizes: [
        {
          index: 1,
          size: null,
          price: null,
        },
      ],
      public: true,
      description: {
        ru: '',
        uz: '',
      },
    })

    const imageBaseUrl = ref(null)

    const showModal = computed({
      get() {
        return props.show
      },
      set(v) {
        emit('update:show', v)
      },
    })

    watch(() => details.value.image, iValue => {
      if (isNull(iValue)) {
        imageBaseUrl.value = null
      }
    })

    watchEffect(async () => {
      if (!isNull(props.id) && showModal.value) {
        try {
          startFetching()
          const response = await findOne({ id: props.id })
          details.value.name.uz = response.data.document.name.uz
          details.value.name.ru = response.data.document.name.ru
          details.value.description.uz = response.data.document.description.uz
          details.value.description.ru = response.data.document.description.ru
          details.value.position = response.data.document.position
          details.value.public = response.data.document.public
          details.value.sizes = response.data.document.sizes
          imageBaseUrl.value = API_BASE_URL + response.data.document.image
        } finally {
          finishFetching()
        }
      }
    })

    function clearForm() {
      details.value.name.uz = ''
      details.value.name.ru = ''
      details.value.description.uz = ''
      details.value.description.ru = ''
      details.value.image = null
      details.value.public = true
      details.value.sizes = []
      details.value.sizes.push({
        size: null,
        price: null,
      })
      details.value.position = null
      imageBaseUrl.value = null
    }

    const isUpdatingRole = computed(() => props.methodType === 'update')

    async function submit() {
      const isValid = await vObserver.value.validate()

      console.log(details.value.sizes)

      if (!isValid) {
        return
      }

      try {
        startLoading()
        if (isUpdatingRole.value) {
          await edit({
            id: props.id,
            body: details.value,
          })
        } else {
          await create({
            body: details.value,
          })
        }

        showModal.value = false
        emit('update:data')
        clearForm()
        vObserver.value.reset()
      } finally {
        finishLoading()
      }
    }

    function addNewSize() {
      details.value.sizes.push({
        index: details.value.sizes.length + 1,
        size: null,
        price: null,
      })
    }

    const refImageEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refImageEl, base64 => {
      imageBaseUrl.value = base64
    })

    function removeSize(szIndex) {
      details.value.sizes.splice(szIndex, 1)
    }

    return {
      vObserver,
      isLoading,
      details,
      isUpdatingRole,
      showModal,
      isFetching,
      refImageEl,
      imageBaseUrl,
      addNewSize,
      clearForm,
      submit,
      inputImageRenderer,
      removeSize,
    }
  },
}
</script>
